import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Homepage.css'; // Using same styles
import './404Page.css'; // Additional 404-specific styles
import Sidebar from '../components/Sidebar';

const NotFoundPage = () => {
  const [darkMode, setDarkMode] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    if (!sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const handleOverlayClick = () => {
    setSidebarOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Random Georgian quiz-related messages
    const errorMessages = [];
  const [randomMessage] = useState(
    errorMessages[Math.floor(Math.random() * errorMessages.length)]
  );

  return (
    <div className={`app-container ${!darkMode ? 'light-mode' : ''}`}>
      <button className="burger-menu" onClick={toggleSidebar}>
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none">
          <path d="M3 12h18M3 6h18M3 18h18"></path>
        </svg>
      </button>
      
      {sidebarOpen && (
        <div className="sidebar-overlay visible" onClick={handleOverlayClick}></div>
      )}
      
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="sidebar-close" onClick={toggleSidebar} aria-label="Close sidebar">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none">
            <path d="M18 6L6 18M6 6l12 12"></path>
          </svg>
        </button>
        <div className="sidebar-content-wrapper">
          <Sidebar darkMode={darkMode} setDarkMode={setDarkMode} />
        </div>
      </div>
      
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="error-404-container">
          <div className="error-404-content">
            {/* Large 404 Display */}
            <div className="error-404-number">
              <span className="digit-4">4</span>
              <span className="digit-0">0</span>
              <span className="digit-4">4</span>
            </div>
            
            {/* Error Title */}
            <h1 className="error-404-title">გვერდი ვერ მოიძებნა</h1>
            
            {/* Random Georgian Message */}
            <p className="error-404-message">{randomMessage}</p>
            
            {/* Description */}
            <p className="error-404-description">
              თქვენ მიერ მოთხოვნილი გვერდი არ არსებობს ან გადატანილია სხვა მისამართზე.
            </p>
            
            {/* Action Buttons */}
            <div className="error-404-actions">
              <button 
                className="error-404-button primary"
                onClick={() => navigate('/')}
              >
                <svg className="button-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                </svg>
                მთავარზე დაბრუნება
              </button>
              
              <button 
                className="error-404-button secondary"
                onClick={() => navigate(-1)}
              >
                <svg className="button-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                უკან დაბრუნება
              </button>
            </div>
            
            {/* Search Suggestion */}
            <div className="error-404-suggestion">
              <p className="suggestion-text">შეგიძლიათ სცადოთ კითხვების ძებნა:</p>
              <Link to="/" className="suggestion-link">
                კითხვების ძებნა →
              </Link>
            </div>
            
            {/* Decorative Elements */}
            <div className="error-404-decoration">
              <div className="decoration-circle circle-1"></div>
              <div className="decoration-circle circle-2"></div>
              <div className="decoration-circle circle-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;